import { openOverlay, closeOverlay } from "./overlaySlice";

console.log("Hello: ", openOverlay, closeOverlay)

export {closeOverlay, openOverlay}